export default "__VITE_ASSET__a$djv0AH__"